import { Box, ListView } from '@razorpay/blade/components';
import React, { useState } from 'react';
import { EarningsDetailView, EarningsFilters, EarningsListView } from './index';
import { statusFilters } from 'components/SalaryComponents/constants';

const EarningsView = () => {
  const [counts, setCounts] = useState<Record<keyof typeof statusFilters, number>>();

  return (
    <>
      <Box paddingX="spacing.8" marginTop="spacing.5">
        <ListView>
          <EarningsFilters counts={counts} />
          <EarningsListView onCountChange={setCounts} />
        </ListView>
        <EarningsDetailView />
      </Box>
    </>
  );
};

export default EarningsView;
